import sys_manage_dict_add from './dict-add';
import sys_manage_dict_detail from './dict-detail';
import sys_manage_dict_edit from './dict-edit';
import sys_manage_dict_list from './dict-list';

export default {
    sys_manage_dict_add,
    sys_manage_dict_detail,
    sys_manage_dict_edit,
    sys_manage_dict_list,
};
